/* styles.ts generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _14 = "@media (min-width:64rem){._10m437uc{flex-grow:8}._1vdkkb7n{flex-shrink:1}._1wznf1ug{flex-basis:0%}._glten7od{width:unset}._1wznlqvf{flex-basis:35.9rem}}";
const _13 = "._i0dl1osq{flex-basis:100%}";
const _12 = "@media (min-width:64rem){._10m4egat{flex-grow:4}._1vdkkb7n{flex-shrink:1}._1wznf1ug{flex-basis:0%}._glten7od{width:unset}._1wzn9tnu{flex-basis:16.9rem}}";
const _11 = "._1bsb1osq{width:100%}";
const _10 = "._i0dlf1ug{flex-basis:0%}";
const _9 = "._1o9zkb7n{flex-shrink:1}";
const _8 = "._16jlkb7n{flex-grow:1}";
const _7 = "@media (min-width:64rem){._1inivrvc{flex-direction:row}._1jsv1y6m{align-items:flex-start}._pdlmxy5q{gap:var(--ds-space-400,2pc)}._45zz1g80{flex-wrap:wrap}}";
const _6 = "._zulp1jfw{gap:var(--ds-space-500,40px)}";
const _5 = "._1bah1h6o{justify-content:center}";
const _4 = "._4cvr1h6o{align-items:center}";
const _3 = "._2lx21bp4{flex-direction:column}";
const _2 = "._1e0c1txw{display:flex}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _ = "._otyrxy5q{margin-bottom:var(--ds-space-400,2pc)}";
export const TaglineContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_otyrxy5q", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TaglineContainer.displayName = 'TaglineContainer';
}
export const Columns = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3, _4, _5, _6, _7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _zulp1jfw _1inivrvc _1jsv1y6m _pdlmxy5q _45zz1g80", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Columns.displayName = 'Columns';
}
export const LeftColumn = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_8, _9, _10, _11, _12]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _1bsb1osq _10m4egat _1vdkkb7n _1wznf1ug _glten7od _1wzn9tnu", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  LeftColumn.displayName = 'LeftColumn';
}
export const RightColumn = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_8, _9, _13, _11, _14]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_16jlkb7n _1o9zkb7n _i0dl1osq _1bsb1osq _10m437uc _1vdkkb7n _1wznf1ug _glten7od _1wznlqvf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  RightColumn.displayName = 'RightColumn';
}